<template>
	<div class="totals-text">
		<span style="color: #FF1B1B; font-weight: bold"  v-tooltip="tt_appt" >
      <i class="fa fa-calendar-check-o"></i>
      {{ this.numUpcomingAppointments }}</span>
		<span v-tooltip="tt_wait" style="color: #FFDD1B; font-weight: bold"><i class="fa fa-clock-o"></i> {{ this.numGuestWaiting }} </span>
		<span v-tooltip="tt_total"> <i class="fa fa-car"></i> {{ this.numUncompleted }}</span>
	</div>
</template>

<script>
import epoch from 'epoch.js'

const withinAnHour = (datetime) => {
  let diff = (new Date(datetime)).valueOf() - (new Date).valueOf()
  return (diff > 0 && 1000*60*60 > diff)
}

export default {
  data() {
    return {
    tt_appt:"Appointments",
    tt_wait:"Waiting",
    tt_total:"Total"
    }
  },
  computed: {
    trips () {
      return this.$privateReactiveStore.trips
    },
    numGuestWaiting () {
      return this.trips.filter(x => x.waiter && x.active).length
    },
    numUpcomingAppointments () {
      return this.trips.filter(x => x.active && x.appt_time && withinAnHour(x.appt_time)).length
    },
    numUncompleted () {
      return this.trips.filter(x => x.active).length
    }
  }
}
</script>

<style lang="less" scoped>
.totals-text {
	display: flex;
	align-items: flex-start;
	flex-direction: row;
	@media (max-width: 1270px) {
		flex-grow: 2;
		flex-direction: row;
		justify-content: space-around;
  }
  
	span {
		margin: 0 1em;
	}
}


</style>